import React, { useCallback } from 'react';
import { Field, useForm } from 'react-final-form';
import InputField from 'components/InputField';
import { useTranslation } from 'react-i18next';
import validations from 'validations';
import { Button } from 'ncoded-component-library';
import TextAreaField from 'components/TextAreaField';
import ContactNumberField from 'components/ContactNumberField';
import EmailField from 'components/EmailField';

import './ConfirmDetails.styles.scss';
import './ConfirmDetails.styles.responsive.scss';

const TEXT_MAX_LENGTH = 50;

type ConfirmDetailsProps = {
  invalid: boolean; // from Form render, don't use useFormState
  nextStep?: () => void;
};

const ConfirmDetails: React.FC<ConfirmDetailsProps> = (props) => {
  const { invalid, nextStep } = props;

  const { submit } = useForm();

  const { t } = useTranslation();

  const onConfirm = useCallback(() => {
    if (invalid) {
      submit();
      return;
    }

    nextStep ? nextStep() : submit();
  }, [invalid, nextStep, submit]);

  return (
    <div className="confirm-details">
      <p className="enquiry-title">{t('confirmYourDetails')}</p>
      <div className="fields-container">
        <Field
          label={t('firstName')}
          name="firstName"
          component={InputField}
          validate={validations.composeValidators(
            validations.required(),
            validations.noLongerThan(
              TEXT_MAX_LENGTH,
              t('noLongerThan', { length: TEXT_MAX_LENGTH }),
            ),
          )}
          required
        />
        <Field
          label={t('lastName')}
          name="lastName"
          component={InputField}
          validate={validations.composeValidators(
            validations.required(),
            validations.noLongerThan(
              TEXT_MAX_LENGTH,
              t('noLongerThan', { length: TEXT_MAX_LENGTH }),
            ),
          )}
          required
        />
        <EmailField required />
        <ContactNumberField required />
      </div>
      <div>
        <Field
          name="context"
          label={t('addContextToYourEnquiry')}
          component={TextAreaField}
          maxLength={1000}
          rows="4"
        />
      </div>
      <div className="actions">
        <span />

        <Button onClick={onConfirm}>{t('confirmDetails')}</Button>
      </div>
    </div>
  );
};

export default ConfirmDetails;
